export default "__VITE_ASSET__C1x2rCr7__"